
<template>
  <v-layout class="text-xs-center">
    <v-dialog v-model="versionNotMatchDialog" persistent width="400">
      <v-card>
        <v-card-title class="headline error" primary-title style="color: white;">{{$t('Warning')}}</v-card-title>
        <v-card-text>
          <!-- <h3>{{$t('UnablePlaceOrderTxt')}}</h3> -->
          <h3>Version Not Match</h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="restart()">{{$t('Ok')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      versionNotMatchDialog: true
    }
  },
  created: function() {},
  destroyed() {
    console.log('destroy')
  },
  methods: {
    restart() {
      this.versionNotMatchDialog = false

      sessionStorage.clear()
      this.$router.go(0)
    }
  }
}
</script>
